const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function retryRequest(
  requestFn,
  { maxRetries = 5, baseDelayMs = 1000 } = {},
) {
  for (let attempt = 0; ; attempt++) {
    const response = await requestFn();

    if (response?.status !== 429) {
      return response;
    }

    if (attempt >= maxRetries) {
      throw new Error("Too many requests. Maximum retry attempts reached.");
    }

    const retryAfter = response.headers?.get?.("Retry-After");
    const retryAfterSeconds = retryAfter ? Number(retryAfter) : NaN;

    const delayMs =
      Number.isFinite(retryAfterSeconds) && retryAfterSeconds >= 0
        ? retryAfterSeconds * 1000
        : baseDelayMs * Math.pow(2, attempt);

    await delay(delayMs);
  }
}
